import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useState } from 'react';

export function useDeleteAccount(props) {
    const {
        selectedBillingSetup,
        deleteAccount_requesting,
        isAccountRecordUpdatedSuccessfully,
    } = props;

    const [isModalVisible_deleteBillingSetup, setIsModalVisible_deleteBillingSetup] = useState(false);

    function validateOnDelete(selectedAccounts) {
        if (func_validation.isArrayNotEmpty(selectedAccounts)) {
            setIsModalVisible_deleteBillingSetup(true);

            if (func_validation.isFunction(props.setSelectedBillingSetup)) 
                props.setSelectedBillingSetup(selectedAccounts);
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 row.",
            });
        }
    }
    function handleAccount_delete() {
        if (func_validation.isArrayNotEmpty(selectedBillingSetup)) {
            selectedBillingSetup.map((billingSetup) => {
                let billingSetupId = func_validation.getObjectPropertyValue(billingSetup, "Id");

                if (func_validation.isNumberValid(billingSetupId) &&
                    props.deleteAccount)
                    props.deleteAccount(billingSetupId);
            });
        }
    }

    let deleteAccountModal = (
        <ConfirmationModal
            className={"recursiveBillingSetup-deleteAccount"}
            headerClassName={"recursiveBillingSetup-deleteAccount-header"}
            description={"The selected billing setup(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_deleteBillingSetup}
            updateParentState={setIsModalVisible_deleteBillingSetup}
            handleOnConfirm={handleAccount_delete}
            isActionLoading={deleteAccount_requesting}
            isConfirmSuccessful={isAccountRecordUpdatedSuccessfully}
        />
    );
    
    return {
        validateOnDelete,
        handleAccount_delete,
        deleteAccountModal
    }
}